import isNull from 'lodash/isNull';
import React, { useState, useEffect, Suspense } from 'react';
import { fetchFavouriteSports } from '~shared/utils/favourite-sports';
import {
    setOnboardingPageOpen,
} from '~shared/utils/user';
import { useFavouriteSports } from '~SpectateStore/hooks/userHooks';
import LoadingIndicator from '~shared/components/react/LoadingIndicator';

const FavoriteSportModal = React.lazy(() => import('./FavoriteSportModal'));

const FavoriteSportModalWrapper = () => {
    const [aToZSports, setAToZSports] = useState([]);
    const [popularSports, setPopularSports] = useState([]);
    const favouriteSports = useFavouriteSports();

    useEffect(() => {
        const fetchData = async () => {
            const sportData = await fetchFavouriteSports();
            if (isNull(sportData)) {
                setOnboardingPageOpen(false);
            }
            const {
                a_z: aToZSports = [],
                popular: popularSports = [],
            } = sportData || {};

            setAToZSports(aToZSports);
            setPopularSports(popularSports);
        };
        fetchData();
    }, []);

    return <Suspense fallback={<LoadingIndicator />}>
                <FavoriteSportModal
                    popularSports={popularSports}
                    aToZSports={aToZSports}
                    favouriteSports={favouriteSports}
                />
            </Suspense>;
};

export default FavoriteSportModalWrapper;
